<template>
  <!-- 自动接收信息设置 -->
  <div class="Automatic">
    <div class="Automatic-content">
      <div class="Automatic-top">
        <h1>供应商自动接收信息设置</h1>
      </div>
      <div class="Collection-main">
        <el-form class="Form-style">
          <el-checkbox-group v-model="check" @change="changCheck">
            <el-checkbox :label="1">若客户购买我提供的专属商品，自动确认订单。</el-checkbox>
          </el-checkbox-group>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  import { mapState } from 'vuex'
  import { Objects } from "@/assets/utils/Object"
  import { Arrays } from "@/assets/utils/Array"
  export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
      return {
        check: []
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapState(['supplierBasics'])
    },
    // 监控data中的数据变化
    watch: {
      'supplierBasics': {
        handler(value) {
          if (this.$Objects(value.personSupplier)) {
            if (value.personSupplier.otherResourceData.autoReception === 1) this.check.push(1)
          }

          if (this.$Objects(value.mechanismSupplier)) {
            if (value.mechanismSupplier.autoReception === 1) this.check.push(1)
          }
        },
        deep: true
      }
    },
    // 方法集合
    methods: {
      changCheck(e) {
        if (this.$Objects(this.$store.state.supplierBasics.personSupplier)) {
          if (this.check.find(x => x == 1)) this.$store.state.supplierBasics.personSupplier.otherResourceData.autoReception = 1
        }
        if (this.$Objects(this.$store.state.supplierBasics.mechanismSupplier)) {
          if (this.check.find(x => x == 1)) this.$store.state.supplierBasics.mechanismSupplier.autoReception = 1
        }
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style scoped lang="scss">
  .Automatic {
    //width: 12.8rem;
    margin: 0 auto;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.11);
    border-radius: 6px 6px 6px 6px;
    background-color: rgba(255, 255, 255, 1);
    margin: 15px auto;

    .Automatic-content {
      padding: 30px;
    }

    .Automatic-top {
      display: flex;
      justify-content: space-between;
    }

    .Form-style {
      padding-top: 15px;
    }

    .Form-style /deep/.el-input {
      width: 5rem;
    }

    .Form-style /deep/.el-input__inner {
      border: none;
      background: none;
      border-radius: 0 !important;
      padding-left: 0;
      font-size: 14px;
      font-family: PingFangSC-light;
    }

    .Form-style /deep/.el-form-item__label {
      font-size: 14px;
      border-radius: 0 !important;
      padding-right: 150px;
      font-family: PingFangSC-light;
      width: 5rem;
      text-align: left;
    }

    .Form-style /deep/.el-form-item {
      display: flex;
      border-bottom: 1.3px dashed rgba(242, 237, 237, 1);
    }
  }
</style>